import {Injectable} from '@angular/core';

import {BehaviorSubject, Observable} from 'rxjs';
import {shareReplay, tap} from 'rxjs/operators';

import {SsoTypeEnum, FeatureEnum} from '../models/models.interfaces';
import {ApiService} from '../shared/api';
import {DocumentsOffering, DocumentsOfferingNames} from '../shared/documents/documents.interface';

export interface CliCoreProperties {
  accountingManagementEnabled: boolean;
  templateManagementEnabled: boolean;
  sdconnectEnabled: boolean;
  paymentV2Enabled: boolean;
  onboardingAdminEnabled: boolean;
  newOnboardingEnabled: boolean;
  documentsOffering: DocumentsOfferingNames;
  maxDocuments: number;
  maxUploadSize: number;
  ssoType: SsoTypeEnum;
  languages: string[];
  features: FeatureEnum[];
}

@Injectable({
  providedIn: 'root'
})
export class CliCorePropertiesService {
  private cache$: Observable<CliCoreProperties>;

  public documentsOfferingBehaviorSubject: BehaviorSubject<DocumentsOffering> = new BehaviorSubject<DocumentsOffering>(null);
  public ssoTypeBehaviorSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(private api: ApiService) {
  }

  public get(): Observable<CliCoreProperties> {
    if (!this.cache$) {
      this.cache$ = this.api.get(`/ga/api/v1/cli-core-properties`).pipe(
        tap((value) => {
          localStorage.setItem('gp_accounting_management_enabled', String(value.accountingManagementEnabled));
          localStorage.setItem('gp_template_management_enabled', String(value.templateManagementEnabled));
          localStorage.setItem('gp_sdconnect_enabled', String(value.sdconnectEnabled));
          localStorage.setItem('gp_payment_v2_enabled', String(value.paymentV2Enabled));
          localStorage.setItem('gp_onboarding_admin_enabled', String(value.onboardingAdminEnabled));
          localStorage.setItem('gp_new_onboarding_enabled', String(value.newOnboardingEnabled));
          this.documentsOfferingBehaviorSubject.next({
            value: value.documentsOffering,
            maxDocuments: value.maxDocuments,
            maxUploadSize: value.maxUploadSize
          });
          this.ssoTypeBehaviorSubject.next(value.ssoType);
        }),
        shareReplay({bufferSize: 1, refCount: false})
      );
    }
    return this.cache$;
  }

}
